export default __webpack_public_path__ + "static/media/logo-tsul-dark.1dc3af1c.png";